import {Link} from "react-router";
import {Button} from "@/components/ui/button.tsx";
import {ArrowLongLeftIcon, CreditCardIcon} from "@heroicons/react/24/outline";
import {HeadphonesIcon} from "@/assets/icons/outline/Headphones.tsx";
import {ActionCard, ActionCardProps} from "@/pages/overview/components/action-card.tsx";
import {User} from "@/assets/icons/outline/user.tsx";
import {WaterfallIcon} from "@/assets/icons/outline/waterfall.tsx";
import {Send} from "@/assets/icons/outline/send.tsx";
import {Bubble} from "@/assets/icons/outline/bubble.tsx";
import {DoneAllRound} from "@/assets/icons/outline/done_all_round.tsx";
import {PyramidChart} from "@/assets/icons/outline/pyramid_chart.tsx";
import {Head} from "@/layout/Head.tsx";
import {SumCallsSystem} from "@/pages/overview/components/SumCallsSystem.tsx";

const actionsCards: ActionCardProps[] = [
    {
        title: "הקלטות",
        description: "כאן תוכלו להעלות הקלטות חדשות לשלוחות",
        link: "/learning/streamfilesclass/",
        color: "yellow",
        icon: HeadphonesIcon,
    },
    {
        title: "משתמשים",
        description: "כאן תוכלו להוסיף משתמש חדש למערכת שלכם",
        link: "/learning/user/",
        color: "green-dark",
        icon: User,
    },
    {
        title: "שלוחות",
        description: "כאן תוכלו לצפות בשלוחות ולהוסיף שלוחות נוספות",
        link: "/extensions/",
        color: "rose",
        icon: WaterfallIcon,
    },
    {
        title: "שיגור הודעות",
        description: "כאן תוכלו לשגר קמפיין שיחות",
        link: "https://dialer.yeda-phone.com",
        color: "blue",
        icon: Send,
    },
    {
        title: "צפיה בעיסקאות",
        description: "כאן תוכלו לראות את כמות התשלומים וסטטוס העיסקאות שבוצעו במערכת שלכם",
        link: "/learning/result/?display_mode=status_credit&fields=%D7%9E%D7%A1%D7%A4%D7%A8+%D7%90%D7%A9%D7%A8%D7%90%D7%99%2C%D7%AA%D7%95%D7%A7%D7%A3+%D7%90%D7%A9%D7%A8%D7%90%D7%99%2CCVV%2C%D7%9E%D7%A1%D7%A4%D7%A8+%D7%96%D7%94%D7%95%D7%AA%2C%D7%A1%D7%95%D7%92+%D7%A2%D7%A1%D7%A7%D7%94%2C%D7%A1%D7%9B%D7%95%D7%9D%2C%D7%AA%D7%A9%D7%9C%D7%95%D7%9E%D7%99%D7%9D%2C%D7%9E%D7%A1%D7%A4%D7%A8+%D7%A2%D7%A1%D7%A7%D7%94%2C%D7%94%D7%A7%D7%9C%D7%98%D7%AA+%D7%A9%D7%9D%2C%D7%94%D7%A7%D7%9C%D7%98%D7%AA+%D7%9B%D7%AA%D7%95%D7%91%D7%AA%2C%D7%98%D7%9C%D7%A4%D7%95%D7%9F+%D7%9C%D7%91%D7%99%D7%A8%D7%95%D7%A8%D7%99%D7%9D%2C%D7%98%D7%9C%D7%A4%D7%95%D7%9F+%D7%9E%D7%A2%D7%A8%D7%9B%D7%AA%2C%D7%9E%D7%A1%D7%95%D7%A3%2C%D7%A1%D7%98%D7%98%D7%95%D7%A1%2C%D7%9B%D7%9E%D7%95%D7%AA",
        color: "blue",
        icon: CreditCardIcon,
    },
    {
        title: "יחידות",
        description: "כאן תוכלו לרכוש יחידות נוספות לשימוש במערכת שלכם",
        link: "/system/account",
        color: "orange",
        icon: Bubble,
    },
    {
        title: "שאלונים",
        description: "כאן תוכלו להוסיף שאלון חדש במערכת שלכם",
        link: "/learning/sclasstest/",
        color: "gray",
        icon: DoneAllRound,
    },
    {
        title: 'תורים',
        description: 'כאן תוכלו לראות את יומן השיחות בתור, כמות הממתינים למענה, ושיחות שלא נענו.',
        link: '/learning/queue',
        color: 'green',
        icon: PyramidChart,
    }
]

export function OverviewPage() {
    return (
        <div className="font-normal px-4 py-4 sm:px-6 sm:py-6 md:px-9 md:py-9 space-y-6 max-w-[1350px] mx-auto">
            <Head title="מבט כללי"/>

            <SumCallsSystem/>

            <div>
                <div className="px-6">
                    <div className="border-b pb-5">
                        <Button asChild variant="link" className="font-normal p-0">
                            <Link to="">
                                <span className="font-semibold">מה חדש בידע פון:</span>
                                <span>הדרכות מלאות וחדשות לניהול המערכת</span>
                                <span><ArrowLongLeftIcon className="w-5 h-5"/></span>
                            </Link>
                        </Button>
                    </div>
                </div>
            </div>

            <div>
                <div className="text-sm font-semibold">
                    בוקר טוב, מה נבצע היום?
                </div>
                <div>
                    <h2 className="text-xl font-semibold leading-8">פעולות נפוצות</h2>
                    <div className="grid pt-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-7">
                        {actionsCards.map((action, index) => (
                            <ActionCard
                                key={index}
                                title={action.title}
                                description={action.description}
                                link={action.link}
                                color={action.color}
                                icon={action.icon}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
